var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff715d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scribble_2",
    "data-name": "scribble 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M538.21,223.48A127.48,127.48,0,0,1,618.32,297c9.66,24.13,12.28,52,29.32,71.66,21.94,25.25,59.44,27.95,92.84,29.71s71.31,6.87,90.43,34.32c22.79,32.71,6.64,79.86,24,115.78,15.38,31.91,52.42,46.24,86.53,55.8s71.39,18.93,93.3,46.77c23.12,29.36,21.27,74.3-1,104.33s-61.71,44.9-98.94,41.5S863,773.3,837.91,745.6s-41.35-62.52-51.44-98.51c-8.71-31.07-15.74-67.19-43.62-83.45-31.36-18.29-75.27-2-105.1-22.73-36-25-27.51-86.27-62.24-113-26.12-20.13-63.44-11.13-96-16.51-37.36-6.18-70.29-34.14-82.45-70-10.76-31.71-6.62-84.7,25.14-104.07C453.17,218.42,504.46,213.24,538.21,223.48Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects19);
export default __webpack_public_path__ + "static/media/objects-19.a5c28c01ec917609dfd143af18f2dddd.svg";
export { ForwardRef as ReactComponent };